import { useMemo } from 'react';
import { APP_NAME, MULTI_SHOP_BRAND_NAME, SINGLE_SHOP_DISPLAY_NAME_OVERRIDE } from '@core/config/constants';
import { MULTI_SHOP_ENABLED, getFirstShopId } from '@core/config/shops';
import { useTenantShops } from './TenantShopsContext';

/**
 * Name shown in header, footer, and document title.
 * - Multi-shop: source-controlled `STOREFRONT_CONFIG.multiShopBrandName`.
 * - Single-shop: `mst_shop.shop_name` (or `name` if exposed), else source config override, else `VITE_APP_NAME` / Storefront.
 */
export function useStoreDisplayName(): string {
  const { shops } = useTenantShops();

  return useMemo(() => {
    if (MULTI_SHOP_ENABLED) {
      return MULTI_SHOP_BRAND_NAME;
    }
    const sid = getFirstShopId(shops);
    const row = shops.find((s) => s.id === sid);
    const fromDb = row?.name?.trim();
    if (fromDb) return fromDb;
    const fromEnvShop = SINGLE_SHOP_DISPLAY_NAME_OVERRIDE;
    if (fromEnvShop) return fromEnvShop;
    return APP_NAME;
  }, [shops]);
}
